import React from 'react';
import styled from '@emotion/styled';
import { Skeleton } from '@mui/material';
import breakpoints from '../Theme/breakpoints';
import { TextSkeletons } from './HomePage';

const Container = styled.div`
  width: 100%;

  @media (min-width: ${breakpoints.sm}px) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

const MostReadItem = styled.div`
  display: flex;
  flex: 0 0 30%;
  padding-right: 3%;
  padding-top: 3rem;
  
  .MuiSkeleton-root {
    width: 100%;
  }
`;

const Text = styled.div`
  width: 100%;
`;

const Circle = styled.div`
  margin-right: 1.25rem;

  .MuiSkeleton-root {
    width: 22px;
    height: 22px;

    @media (min-width: ${breakpoints.md}px) {
      width: 44px;
      height: 44px;
    }
  }


`;

const MostReadItemElement = () => (
  <MostReadItem>
    <Circle>
      <Skeleton variant="circular" />
    </Circle>
    <Text>
      <TextSkeletons />
    </Text>
  </MostReadItem>
);

const MostRead = () => (
  <Container>
    <MostReadItemElement />
    <MostReadItemElement />
    <MostReadItemElement />
    <MostReadItemElement />
    <MostReadItemElement />
    <MostReadItemElement />
  </Container>
);

export default MostRead;
